import { Button, Modal, Space, InputNumber } from "antd";
import React, { useState } from "react";
import { EditFilled } from "@ant-design/icons";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Notification } from "../../Notification";

const initialState = null;

export const ProductionPopup = (props) => {
   const [isModalOpen, setIsModalOpen] = useState(initialState);
   const [costs, setCosts] = useState(initialState);
   const [adjustRunningMeters, setAdjustingRunningMeters] = useState(initialState);
   const [runningMetersMin, setRunningMetersMin] = useState(initialState);
   const [timeperminute, setTimeperminute] = useState(initialState);

   const showModal = async () => {
      setIsModalOpen(true);
      setCosts(props.costs);
      setAdjustingRunningMeters(props.adjustRunningMeters);
      setRunningMetersMin(props.runningMetersMin);
      setTimeperminute(props.timeperminute);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      setCosts(initialState);
      setAdjustingRunningMeters(initialState);
      setRunningMetersMin(initialState);
      setTimeperminute(initialState);
   };

   const updateData = async (e) => {
      e.preventDefault();
      const ref = doc(db, "productionCosts", props.id);
      await updateDoc(ref, {
         costs: costs,
         id: props.id,
      })
         .then(() => {
            setIsModalOpen(true);
            setCosts(initialState);
            setAdjustingRunningMeters(initialState);
            setRunningMetersMin(initialState);
            setTimeperminute(initialState);
            Notification("success", "Updated!", "Your data has been updated");
         })
         .then(() => {
            setIsModalOpen(false);
         })
         .catch((err) => {
            Notification("error", "Login Error", err.message);
         });
   };
   return (
      <>
         <Button size="small" type="primary" onClick={showModal}>
            <EditFilled />
         </Button>
         <Modal width={900} title={"Production Costs for " + props.title} open={isModalOpen} onOk={updateData} onCancel={handleCancel}>
            <Space>
               <InputNumber addonBefore="Costs :" value={costs} style={{ width: "100%" }} onChange={(value) => setCosts(value)} />
               <InputNumber
                  addonBefore="Adjust Meters :"
                  value={adjustRunningMeters}
                  style={{ width: "100%" }}
                  onChange={(value) => setAdjustingRunningMeters(value)}
               />
               <InputNumber addonBefore="Meters/Min :" value={runningMetersMin} style={{ width: "100%" }} onChange={(value) => setRunningMetersMin(value)} />
               <InputNumber addonBefore="Timer per Min :" value={timeperminute} style={{ width: "100%" }} onChange={(value) => setTimeperminute(value)} />
            </Space>
         </Modal>
      </>
   );
};
